// Dica (tooltip) dos botões de ação, ex.: "Adicionar à lista de desejos".
//
// Substitui o v-b-popover nesses botões: o popover do bootstrap-vue limitava a
// dica ao quadro do conteúdo da página e, nos cards da primeira linha (sem
// espaço acima do botão), empurrava a dica para cima do próprio botão. Aqui a
// dica é desenhada no <body> (position: fixed), sempre ACIMA do botão e, quando
// não houver espaço acima (cabeçalho/topo da tela), ABAIXO dele - nunca sobre
// o botão.
//
// Uso: v-mx3-tip="'Texto da dica'"
//      v-mx3-tip.bottom="'Texto'"  -> prefere ABAIXO do botão (acima só se não couber).

const GAP = 10; // distância entre a dica e o botão
const MARGIN = 8; // folga mínima das bordas da tela

let tipEl = null;
let styleEl = null;
let atual = null; // elemento que está exibindo a dica

function garantirEstilo() {
  if (styleEl || typeof document === 'undefined') return;
  styleEl = document.createElement('style');
  styleEl.setAttribute('data-mx3-tip', '');
  styleEl.textContent = `
.mx3-tip {
  position: fixed;
  z-index: 100000;
  top: 0;
  left: 0;
  max-width: min(280px, calc(100vw - 16px));
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 0.875rem;
  line-height: 1.35;
  font-weight: 500;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  background: var(--bs-popover-bg, var(--bs-body-bg, #fff));
  color: var(--bs-body-color, #212529);
  border: 1px solid var(--bs-border-color-translucent, rgba(0, 0, 0, 0.2));
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.22);
  transition: opacity 0.12s ease;
}
.mx3-tip.is-visible { opacity: 1; visibility: visible; }
.mx3-tip::after {
  content: '';
  position: absolute;
  left: var(--mx3-tip-arrow-x, 50%);
  width: 10px;
  height: 10px;
  margin-left: -5px;
  background: inherit;
  border: inherit;
  transform: rotate(45deg);
}
.mx3-tip[data-pos='top']::after {
  bottom: -6px;
  border-top-color: transparent;
  border-left-color: transparent;
}
.mx3-tip[data-pos='bottom']::after {
  top: -6px;
  border-bottom-color: transparent;
  border-right-color: transparent;
}`;
  document.head.appendChild(styleEl);
}

function garantirTip() {
  if (tipEl || typeof document === 'undefined') return tipEl;
  garantirEstilo();
  tipEl = document.createElement('div');
  tipEl.className = 'mx3-tip';
  tipEl.setAttribute('role', 'tooltip');
  document.body.appendChild(tipEl);
  return tipEl;
}

// Parte inferior da área ocupada pelo cabeçalho (fixo/colante), para a dica
// nunca ser posicionada por baixo dele.
function limiteSuperior() {
  let fundo = 0;
  const header = document.getElementById('header');
  if (header) {
    fundo = Math.max(fundo, header.getBoundingClientRect().bottom);
    const barra = header.querySelector('.main-header');
    if (barra && window.getComputedStyle(barra).position === 'fixed') {
      fundo = Math.max(fundo, barra.getBoundingClientRect().bottom);
    }
  }
  return Math.max(MARGIN, fundo + 4);
}

function posicionar(el) {
  const tip = garantirTip();
  if (!tip || !el) return;
  const alvo = el.getBoundingClientRect();
  const w = tip.offsetWidth;
  const h = tip.offsetHeight;
  const vw = document.documentElement.clientWidth;
  const vh = window.innerHeight;

  // Acima do botão; se não couber (cabeçalho/topo), abaixo; nunca sobre ele.
  // Com o modificador .bottom: abaixo do botão; se não couber, acima.
  let pos = 'top';
  let top = alvo.top - GAP - h;
  if (el.__mx3TipBottom) {
    pos = 'bottom';
    top = alvo.bottom + GAP;
    if (top + h > vh - MARGIN && alvo.top - GAP - h >= limiteSuperior()) {
      pos = 'top';
      top = alvo.top - GAP - h;
    }
  } else if (top < limiteSuperior()) {
    pos = 'bottom';
    top = alvo.bottom + GAP;
    if (top + h > vh - MARGIN) {
      // Sem espaço abaixo: volta para cima, mesmo encostando no limite.
      pos = 'top';
      top = Math.max(MARGIN, alvo.top - GAP - h);
    }
  }

  const centro = alvo.left + alvo.width / 2;
  let left = centro - w / 2;
  left = Math.min(Math.max(MARGIN, left), Math.max(MARGIN, vw - MARGIN - w));
  const setaX = Math.min(Math.max(14, centro - left), Math.max(14, w - 14));

  tip.setAttribute('data-pos', pos);
  tip.style.setProperty('--mx3-tip-arrow-x', setaX + 'px');
  tip.style.transform = `translate(${Math.round(left)}px, ${Math.round(top)}px)`;
}

// O card sobe e o botão aparece com animação ao passar o mouse: enquanto isso o
// botão muda de lugar. A dica acompanha o botão durante a animação (e segue
// posicionada depois), para nunca ficar sobre ele.
let rafId = null;
function seguir(el, ate) {
  if (rafId) window.cancelAnimationFrame(rafId);
  const passo = () => {
    if (atual !== el) {
      rafId = null;
      return;
    }
    posicionar(el);
    rafId = performance.now() < ate ? window.requestAnimationFrame(passo) : null;
  };
  rafId = window.requestAnimationFrame(passo);
}

function mostrar(el) {
  const texto = el.__mx3TipText;
  if (!texto) return;
  const tip = garantirTip();
  if (!tip) return;
  atual = el;
  tip.textContent = texto;
  tip.classList.remove('is-visible');
  posicionar(el);
  // força o reflow para a transição de opacidade
  void tip.offsetWidth;
  tip.classList.add('is-visible');
  seguir(el, performance.now() + 600);
}

function esconder(el) {
  if (el && atual && el !== atual) return;
  atual = null;
  if (rafId) {
    window.cancelAnimationFrame(rafId);
    rafId = null;
  }
  if (tipEl) tipEl.classList.remove('is-visible');
}

function reposicionar() {
  if (atual) posicionar(atual);
}

let globais = false;
function ligarGlobais() {
  if (globais || typeof window === 'undefined') return;
  globais = true;
  window.addEventListener('scroll', reposicionar, { passive: true, capture: true });
  window.addEventListener('resize', reposicionar);
}

export default {
  bind(el, binding) {
    el.__mx3TipText = binding.value || '';
    el.__mx3TipBottom = !!(binding.modifiers && binding.modifiers.bottom);
    el.__mx3TipShow = () => mostrar(el);
    el.__mx3TipHide = () => esconder(el);
    el.addEventListener('mouseenter', el.__mx3TipShow);
    el.addEventListener('focus', el.__mx3TipShow);
    el.addEventListener('mouseleave', el.__mx3TipHide);
    el.addEventListener('blur', el.__mx3TipHide);
    el.addEventListener('click', el.__mx3TipHide);
    ligarGlobais();
  },
  update(el, binding) {
    if (binding.value === binding.oldValue) return;
    el.__mx3TipText = binding.value || '';
    if (atual === el && tipEl) {
      tipEl.textContent = el.__mx3TipText;
      posicionar(el);
    }
  },
  unbind(el) {
    esconder(el);
    el.removeEventListener('mouseenter', el.__mx3TipShow);
    el.removeEventListener('focus', el.__mx3TipShow);
    el.removeEventListener('mouseleave', el.__mx3TipHide);
    el.removeEventListener('blur', el.__mx3TipHide);
    el.removeEventListener('click', el.__mx3TipHide);
    delete el.__mx3TipText;
    delete el.__mx3TipBottom;
    delete el.__mx3TipShow;
    delete el.__mx3TipHide;
  },
};
